export default function() {
  const widgetName = 'fairgroundsSeoWidget';
  const widgetOpts = fairgroundsSeoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {},
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false,
    textOverImage: false
  });

}